/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationSettingsDto } from '../models/application-settings-dto';
import { getSettings } from '../fn/application-settings/get-settings';
import { GetSettings$Params } from '../fn/application-settings/get-settings';
import { updateSetting } from '../fn/application-settings/update-setting';
import { updateSetting_1 } from '../fn/application-settings/update-setting-1';
import { UpdateSetting_1$Params } from '../fn/application-settings/update-setting-1';
import { UpdateSetting$Params } from '../fn/application-settings/update-setting';

@Injectable({ providedIn: 'root' })
export class ApplicationSettingsService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSettings()` */
  static readonly GetSettingsPath = '/api/application/settings';

  /**
   * Get Settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Response(params?: GetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsDto>> {
    return getSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings(params?: GetSettings$Params, context?: HttpContext): Observable<ApplicationSettingsDto> {
    return this.getSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettingsDto>): ApplicationSettingsDto => r.body)
    );
  }

  /** Path part for operation `updateSetting()` */
  static readonly UpdateSettingPath = '/api/application/settings';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting$Response(params: UpdateSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsDto>> {
    return updateSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting(params: UpdateSetting$Params, context?: HttpContext): Observable<ApplicationSettingsDto> {
    return this.updateSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettingsDto>): ApplicationSettingsDto => r.body)
    );
  }

  /** Path part for operation `updateSetting_1()` */
  static readonly UpdateSetting_1Path = '/api/application/settings/AvWeight';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_1$Response(params: UpdateSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsDto>> {
    return updateSetting_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_1(params: UpdateSetting_1$Params, context?: HttpContext): Observable<ApplicationSettingsDto> {
    return this.updateSetting_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettingsDto>): ApplicationSettingsDto => r.body)
    );
  }

}
